import React, { useContext, useState } from "react";
import { CartContext } from "./CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import { Link } from "react-router-dom";
import siteConfig from "../siteConfig";

const supportedCountries = [
  "Australia", "Austria", "Belgium", "Brazil", "Bulgaria", "Canada", "Chile", "Colombia",
  "Croatia", "Cyprus", "Czech Republic", "Denmark", "Estonia", "Finland", "France", "Germany",
  "Greece", "Hong Kong", "Hungary", "Iceland", "Ireland", "Israel", "Italy", "Japan", "Latvia",
  "Lithuania", "Luxembourg", "Malaysia", "Malta", "Mexico", "Netherlands", "New Zealand", "Norway",
  "Philippines", "Poland", "Portugal", "Romania", "Singapore", "Slovakia", "Slovenia", "South Africa",
  "South Korea", "Spain", "Sweden", "Switzerland", "Taiwan", "Thailand", "United Arab Emirates",
  "United Kingdom", "United States", "Vietnam"
];

const makeOrderNumber = () => {
  const random = typeof crypto !== "undefined" && crypto.getRandomValues
    ? crypto.getRandomValues(new Uint32Array(2)).join("")
    : Math.floor(Math.random() * 1e16).toString();
  return `${Date.now()}${random}`;
};

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    email: "", country: "United States", firstName: "", lastName: "",
    address: "", apartment: "", city: "", region: "", postcode: ""
  });
  const lines = cartItems
    .map((item) => ({ ...item, product: productData.find((p) => p.id === item.id) }))
    .filter((item) => item.product);
  const subtotal = lines.reduce((sum, item) => sum + item.product.price * item.quantity, 0);
  const shipping = siteConfig.shipping.flatRate;
  const total = subtotal + shipping;
  const update = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    const required = ["email", "country", "firstName", "lastName", "address", "city", "region", "postcode"];
    const next = Object.fromEntries(required.filter((key) => !form[key].trim()).map((key) => [key, "Required"]));
    if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) next.email = "Enter a valid email";
    setErrors(next);
    if (Object.keys(next).length) return;

    const origin = window.location.origin;
    const params = new URLSearchParams({
      orderNo: makeOrderNumber(),
      amount: total.toFixed(2),
      currency: siteConfig.currency,
      email: form.email.trim(),
      success_url: `${origin}/payment?state=success`,
      cancel_url: `${origin}/payment?state=cancel`,
      title: lines[0].product.name,
    });
    window.location.assign(`${origin}/create_payment.php?${params.toString()}`);
  };
  if (!lines.length) return <main className="checkout-empty"><h1>Your bag is empty</h1><Link to="/shop">RETURN TO SHOP</Link></main>;
  const input = (name, placeholder, extra = {}) => <div className="field"><input name={name} value={form[name]} onChange={update} placeholder={placeholder} {...extra} />{errors[name] && <span>{errors[name]}</span>}</div>;

  return <main className="checkout"><div className="checkout-shell">
    <form className="checkout-form" onSubmit={submit} noValidate>
      <Link className="checkout-logo" to="/"><img src="/head/teingshome-logo.svg" alt="teingshome" /></Link>
      <div className="checkout-crumbs">Cart <span>›</span> Information <span>›</span> Secure payment</div>
      <section><h2>Contact</h2>{input("email", "Email address", { type: "email", autoComplete: "email" })}</section>
      <section><h2>Delivery</h2>
        <div className="field"><select name="country" value={form.country} onChange={update} aria-label="Country or region">{supportedCountries.map((country) => <option key={country}>{country}</option>)}</select>{errors.country && <span>{errors.country}</span>}</div>
        <div className="two-col">{input("firstName", "First name", { autoComplete: "given-name" })}{input("lastName", "Last name", { autoComplete: "family-name" })}</div>
        {input("address", "Address", { autoComplete: "street-address" })}
        {input("apartment", "Apartment, suite, etc. (optional)")}
        {input("city", "City", { autoComplete: "address-level2" })}
        <div className="two-col">{input("region", "State / Province / Region", { autoComplete: "address-level1" })}{input("postcode", "Postal code", { autoComplete: "postal-code" })}</div>
      </section>
      <section><h2>Payment</h2><p>You will continue to our secure payment provider to enter payment details.</p><div className="payment-box"><div className="payment-title"><span>Secure hosted checkout</span><span>VISA · Mastercard · AMEX</span></div><p>No card details are collected or stored on teingshome.</p></div></section>
      <button className="pay-button" type="submit">PAY ${total.toFixed(2)} USD</button>
      <Link className="return-cart" to="/cartpage">‹ Return to cart</Link>
    </form>
    <aside className="checkout-summary">{lines.map((item) => <div className="checkout-line" key={`${item.id}-${item.size}-${item.color}`}><div><img src={item.product.image} alt={item.product.name} /><span>{item.quantity}</span></div><p><strong>{item.product.name}</strong><small>{item.color} / {item.size}</small></p><b>${(item.product.price * item.quantity).toFixed(2)}</b></div>)}<div className="checkout-totals"><p><span>Subtotal</span><b>${subtotal.toFixed(2)}</b></p><p><span>Shipping</span><b>${shipping.toFixed(2)}</b></p><p className="checkout-total"><span>Total <small>USD</small></span><b>${total.toFixed(2)}</b></p></div></aside>
  </div></main>;
};

export default CheckOut;
